<template>
    <ContainerContent
        class="mb-8"
        max-class="max-w-sm-floor"
        outer-container
    >
        <v-row>
            <v-col>
                <h1 class="page-title">Sign In</h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <SignIn></SignIn>
            </v-col>
        </v-row>
    </ContainerContent>
</template>

<script lang="ts" setup>
    import SignIn from '~/components/user/SignIn/SignIn.vue';
    import ContainerContent from '~/components/ContainerContent/ContainerContent.vue';
    import {
        getSingleParam
    } from 'x1-base/utils';
    import {
        useCustomAuth,
        useRouteUtils
    } from '~/composables';
    import {
        signInRedirectBlacklist
    } from '~/models'

    const {
        isLoggedIn,
        getRedirect,
        setRedirect,
        clearRedirect
    } = useCustomAuth();
    const $config = useRuntimeConfig();
    const brandTitle = $config.public.brand.title;

    definePageMeta({
        scrollToTop: true,
        pageTransition: true
    });

    useHead({
        title: `Sign In | ${brandTitle}`,
        meta: [
            {
                name: 'description',
                content: 'Sign in to your StringKing account.'
            }
        ]
    });

    const route = useRoute();
    const { canRedirect } = useRouteUtils();
    const redirectFromTo = getRedirectTo();
    const redirectFromParams = getRedirectParams() || redirectFromTo;
    const redirectFromState = getRedirect();

    if (isLoggedIn.value) {
        if (redirectFromTo) {
            clearRedirect();
            await navigateTo(redirectFromTo);
        } else {
            await navigateTo(redirectFromState ??'/');
        }
    } else if (redirectFromParams && canRedirect(signInRedirectBlacklist, redirectFromParams)) {
        setRedirect(redirectFromParams);
    }

    function getRedirectParams(): Nullable<string> {
        return window?.history.state.back ??
            null;
    }

    function getRedirectTo(): Nullable<string> {
        return getSingleParam(route.query, 'to') ??
            getSingleParam(route.query, 'next') ??
            null;
    }
</script>
